import { useCallback } from "react"
import { useMutation } from "urql"

import "../graphql/entityLock.mutation"

import type {
  EntityLockInput,
  ReleaseEntityLockMutation,
  ReleaseEntityLockMutationVariables,
} from "@/graphql/codegen/graphql"
import { ReleaseEntityLockDocument } from "@/graphql/codegen/graphql"

export interface UseReleaseEntityLockReturn {
  release: (input: EntityLockInput) => Promise<void>
  isReleasing: boolean
}

export const useReleaseEntityLock = (): UseReleaseEntityLockReturn => {
  const [{ fetching }, executeMutation] = useMutation<ReleaseEntityLockMutation, ReleaseEntityLockMutationVariables>(
    ReleaseEntityLockDocument
  )

  const release = useCallback(
    async (input: EntityLockInput): Promise<void> => {
      try {
        await executeMutation({ input })
      } catch {
        // AK-6388 — release is fire-and-forget; BE-side idempotent
      }
    },
    [executeMutation]
  )

  return { release, isReleasing: fetching }
}
